import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, Injector, Input, model, OnDestroy, signal, ViewChild } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { IKart, IKartTuru, TurGizlilik, TurGizlilikBilgi } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { ServisUyarProjeler } from '@/src/app/uygulamalar/uyar-dokum/projeler/projeler.service';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { DialogGizlilikSeciciComponent } from '../../dialog-gizlilik-secici/dialog-gizlilik-secici.component';
import { DialogEtiketlerComponent } from '../../dialog-etiketler/dialog-etiketler.component';
import { DialogKisiSeciciComponent } from '../../dialog-kisi-secici/dialog-kisi-secici.component';
import { ServisUyarService } from '@/src/app/uygulamalar/uyar-dokum/servis-uyar.service';
import { RouterModule } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { IParametre } from '@/src/service/fikoyt-ui/interfaces/IParametre/IParametre';
import { FikoYTId } from '@/src/service/fikoyt-ui/helpers/FikoYTId';
import { ParametrelerComponent } from '@/src/service/fikoyt-ui/src/lib/parametreler/parametreler.component';
import { FirmaEkleComponent } from './firma-ekle/.component';
import { TeklifOlusturComponent } from './teklif-olustur/.component';
import { UyarPersonelEkeComponent } from './personel-ekle/.component';

declare var $: any;

@Component({
  selector: 'paylas-uyar-kutusu',
  templateUrl: './uyar-kutusu.component.html',
  styleUrls: ['./uyar-kutusu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    NzPopconfirmModule,
    NzWaveModule,
    NzButtonModule,
    NzInputModule,
    RouterModule,
    FirmaEkleComponent,
    TeklifOlusturComponent,
    UyarPersonelEkeComponent
  ],

})
export class IUyarKartComponent extends FikoYTKokBilesenComponent implements OnDestroy {
  @Input() kart: IKart | undefined;


  /** */
  rota = model("ana-sayfa");


  constructor(public servisUyarProjeler: ServisUyarProjeler, public servisUyar: ServisUyarService) {
    super();
    // setTimeout(() => {
    //   this.CD.detach();
    // })

    this.subsList.push(this.FikoYT.degisti.subscribe(() => {
      this.CD.detectChanges();
    }));
  }


  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }

}
